@if (arrayDataCardCollection.length > 0) {
  <div>
    <ul class="list-group">
      @for (
        ArrayDataCard of arrayDataCardCollection;
        track ArrayDataCard;
        let index = $index
      ) {
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          <div>
            <!--MAKE SURE THE TITLE WORKS. It may align the title to the left. Instead of placing on top of label.-->
            @if (ArrayDataCard.title) {
              <div>
                <label>{{ ArrayDataCard.title }}</label>
                <hr class="divider" />
              </div>
            }
            <div>
              <label>{{ ArrayDataCard.bodyText }}</label>
              <span
                ><i
                  class="bi bi-x-lg x-icon-bold cursor-select"
                  (click)="cardClicked(index, ArrayDataCard)"
                ></i
              ></span>
            </div>
          </div>
        </li>
      }
    </ul>
  </div>
}
